import React, { useContext, useEffect, useState } from 'react';
import CollapsedUspModal from './collapsed-usp-modal';
import ExpandedUspModalMobile from './expanded-usp-modal-mobile';
import { UIContext, MediaContext } from '../context';
import { connect, useSelector } from 'react-redux';
import { useUspHotspotSeparate } from '../hooks/useUspHotspotSeparate';
import { capitalize } from './uspUtils';
import { setIncrementClickedInterior, setDecrementClickedInterior, setToggleInteriorHotspot, setInteriorHotspotIndex, setToggleHotspotView } from '../../../Redux/Reducers/View360Reducer/View360ActionController'

const UspComponentT2MobileInterior = (props) => {
  const { isExpanded, setIsExpanded } = useContext(UIContext);
  const { enterpriseId } = useContext(MediaContext);
  const [isSpanishEnterprise, setIsSpanishEnterprise] = useState(false);
  const interiorHotspotIndex = useSelector(state => state.view360Reducer.interiorHotspotIndex);
  const toggleInteriorHotspots = useSelector(state => state.view360Reducer.toggleInteriorHotspots);
  
  const {
    currentUspIndex,
    currentUsp,
    hotspotData,
    dropdownSelection,
    handleNext,
    handlePrev,
    handleNextCollapsed,
    handlePrevCollapsed,
    toggleExpand: hookToggleExpand,
    handleHotspotClick,
    toggleHotspotView,
    useAutoCycle
  } = useUspHotspotSeparate(props, 'INT');
  
  let spanishEnterprises = ['2d410b1b9','204fffd0d','858b283d5']  // TODO: get from backend
  let isSpanishEnterpriseFn = (enterpriseId) => {
      return spanishEnterprises.includes(enterpriseId);
  }
  
  useEffect(() => {
    if(isSpanishEnterpriseFn(enterpriseId)){
      setIsSpanishEnterprise(true);
    }
  }, [enterpriseId])

  // These are the key useEffect hooks that control isExpanded for interior
  useEffect(() => {
    setIsExpanded((interiorHotspotIndex !== -1 && dropdownSelection === "INT") ? true : false)
  }, [interiorHotspotIndex, toggleInteriorHotspots])

  useAutoCycle(isExpanded);

  const toggleExpand = () => {
    hookToggleExpand(isExpanded, setIsExpanded);
  };

  useEffect(() => {
    if(toggleInteriorHotspots === false){
      setIsExpanded(false);
    }
  }, [toggleInteriorHotspots]);
  
  useEffect(() => {
    if(toggleHotspotView && !isExpanded && dropdownSelection === "INT") {
      handleHotspotClick(setIsExpanded);
    }
  }, [toggleHotspotView, isExpanded, handleHotspotClick, dropdownSelection]);
  
  return (
    <>
      {hotspotData?.length > 0 && dropdownSelection === "INT" && (
        <div className={`w-full h-full ${isExpanded ? 'p-4' : 'px-2'}`}>
        {isExpanded ? (
          <ExpandedUspModalMobile
            capitalize={capitalize}
            dropdownSelection={currentUsp?.type || dropdownSelection}
            modalList={currentUsp || {}}
            uspData={currentUsp}
            onClose={toggleExpand}
            onNext={handleNext}
            onPrev={handlePrev}
            hotspotClickedIndex={interiorHotspotIndex}
            currentItemType={currentUsp?.type}
            isSpanishEnterprise={isSpanishEnterprise}
            currentIndex={(currentUspIndex ?? 0) + 1}
            totalItems={hotspotData?.length || 0}
            combinedHotspotData={hotspotData}
            currentUspIndex={currentUspIndex}
          />
        ) : (
          // Mobile-specific collapsed view for interior
          <div className='w-full h-full bg-green-500 px-3 py-2 rounded-xl shadow-lg text-white'>
            Interior Hotspots - Collapsed View
          </div>
        )}
      </div>
      )}
    </>
  );
};

const mapStateToProps = (state) => ({
  incrementClickedInterior: state.view360Reducer.incrementClickedInterior,
  decrementClickedInterior: state.view360Reducer.decrementClickedInterior,
  toggleInteriorHotspots: state.view360Reducer.toggleInteriorHotspots,
  interiorHotspotIndex: state.view360Reducer.interiorHotspotIndex,
  toggleHotspotView: state.view360Reducer.toggleHotspotView
});

const mapDispatchToProps = {
  setIncrementClickedInterior,
  setDecrementClickedInterior,
  setToggleInteriorHotspot,
  setInteriorHotspotIndex,
  setToggleHotspotView
};

export default connect(mapStateToProps, mapDispatchToProps)(UspComponentT2MobileInterior);
